"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageWrapper = exports.FormErrorMessage = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../../../themes/Base/theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MessageWrapper = _styledComponents.default.div.withConfig({
  displayName: "style__MessageWrapper",
  componentId: "sc-752m5j-0"
})(["z-index:2;position:absolute;top:100%;left:0;box-sizing:border-box;margin:auto;visibility:visible;"]);

exports.MessageWrapper = MessageWrapper;

var FormErrorMessage = _styledComponents.default.div.withConfig({
  displayName: "style__FormErrorMessage",
  componentId: "sc-752m5j-1"
})(["display:flex;align-items:center;font-family:", ";font-size:12.8px;font-weight:600;font-size:16px;line-height:130%;letter-spacing:-0.01em;color:#9d21a9;text-align:left;text-transform:none;padding:4px 0 0;margin:auto;background:transparent;@media (max-width:", "){font-size:12px;}.img-container{display:block;margin-right:14px;width:16px;height:16px;visibility:hidden;svg{object-fit:contain;width:16px;height:16px;}}.active{visibility:visible;}"], function (props) {
  var _props$theme;

  return ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.email_form_font_family) || "FF Mark W05";
}, _theme.size.laptop);

exports.FormErrorMessage = FormErrorMessage;